// extracted by mini-css-extract-plugin
export var fadeInOut = "_4e-3";
export var icon = "_4e-4";
export var savedIndicator = "_4e-2";
export var savingIndicator = "_4e-0";
export var spin = "_4e-1";